export class Address {
    constructor(
        public AddressId: string,
        public PostalCode: string,
        public AddressLine: string,
        public AptSuiteUnit: string,
        public PoBox: string,
        public CityTown: string,
        public Province: string,
        public Country: string
    ) { }

    public formatAddress(): string {
        return this.AddressLine + ', ' + this.CityTown + ' ' + this.Province + ', ' + this.PostalCode
    }

    public formatAddressBold(isBold = true): string {
        if (this.AddressLine != null && this.AddressLine != undefined)
            return (isBold ? '<b>' : '') + (this.AptSuiteUnit ? this.AptSuiteUnit + ' ' : '') + this.AddressLine + (this.PoBox ? ' ' + this.PoBox : '') + '<br>' + this.CityTown + '<br>' + this.Province + ' ' + this.PostalCode + '<br>' + this.Country + (isBold ? '</b>' : '');
        else
            return '';
    }
}

export function mapAddress(address: any): Address {
    return new Address(address.AddressId, address.PostalCode, address.AddressLine, address.AptSuiteUnit, address.PoBox, address.CityTown, address.Province, address.Country)
}